var React = require('react');

function HeroBlob (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M268.092 0.0111357C382.664 1.04398 478.9 81.7906 513.497 191.176C547.285 298.005 511.426 415.8 420.061 480.497C332.031 542.832 215.73 526.883 127.961 464.181C37.4398 399.513 -23.4759 293.214 8.70279 186.626C42.7652 73.798 150.395 -1.04988 268.092 0.0111357Z","fill":"white"}));
}

HeroBlob.defaultProps = {"width":"526","height":"520","viewBox":"0 0 526 520","fill":"none"};

module.exports = HeroBlob;

HeroBlob.default = HeroBlob;
